/**
 * Read optional link from Strapi-shaped or flat news list items.
 */
export function pickUrlStringFromNewsItem(item) {
  if (!item) return "";
  const attrs = item.attributes;
  const candidates = [item.url, item.link, attrs?.url, attrs?.link];
  for (const c of candidates) {
    if (typeof c === "string") {
      const t = c.trim();
      if (t) return t;
    }
  }
  return "";
}

/**
 * Classify a trimmed URL string for news navigation (SPA vs external).
 */
export function classifyNewsNavHref(trimmed) {
  const rawUrl = (trimmed || "").trim();
  if (!rawUrl) return { kind: "none" };

  if (/^https?:\/\//i.test(rawUrl) || rawUrl.startsWith("//")) {
    return { kind: "external", href: rawUrl };
  }
  if (/^(mailto:|tel:)/i.test(rawUrl)) {
    return { kind: "external", href: rawUrl };
  }
  if (/^[a-z][a-z0-9+.-]*:/i.test(rawUrl)) {
    return { kind: "external", href: rawUrl };
  }

  if (rawUrl.startsWith("/")) {
    return { kind: "internal", to: rawUrl };
  }

  // Avoid treating obvious relative file paths as external hosts (e.g. report.pdf).
  if (/\.(html?|pdf|jpg|jpeg|png|gif|webp|svg)(\?|#|$)/i.test(rawUrl)) {
    return { kind: "internal", to: `/${rawUrl.replace(/^\//, "")}` };
  }

  // e.g. www.example.com/path or example.com.hk/foo
  if (/^[\w.-]+\.[a-z]{2,}([\/?#]|$)/i.test(rawUrl)) {
    return { kind: "external", href: `https://${rawUrl}` };
  }

  return { kind: "internal", to: `/${rawUrl.replace(/^\//, "")}` };
}

/**
 * Open external URL; if popup is blocked, navigate in the same tab.
 */
export function openExternalNewsHref(href) {
  if (!href) return;
  const w = window.open(href, "_blank", "noopener,noreferrer");
  if (!w || typeof w.closed === "undefined") {
    window.location.assign(href);
    return;
  }
  try {
    if (w.closed) window.location.assign(href);
  } catch {
    window.location.assign(href);
  }
}
